import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PhotoCameraFrontIcon from '@mui/icons-material/PhotoCameraFront';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import ImageGalleryPanel from '../MenuOptions/VendorPhotos';
import InvoiceDetails from './InvoiceDetails';
import { STATUS_CONFIRMED } from '../../../Util/VMConstants';
import EnquiryVendors from './EnquiryVendors';

const DashboardActionPanel = ({ customer, enquiry_id, events = [], navigate_from, refreshEnquiryDetails, readOnly = false }) => {
  const [activePanel, setActivePanel] = useState('invoice');
  const isConfirmed = customer.appointment_status?.toLowerCase() === STATUS_CONFIRMED.toLowerCase();
  

    useEffect(() => {
      if (navigate_from === 'invoice') {
        setActivePanel('invoice');
      }
    }, [navigate_from]);

  const renderRightPanel = () => {
    switch (activePanel) {
      case 'vendors':
        return <EnquiryVendors customer = {customer} readOnly={readOnly}/>
      case 'photos':
        return <ImageGalleryPanel enquiry_id={enquiry_id} readOnly={readOnly} />;
      case 'invoice':
        return <InvoiceDetails customer={customer} enquiry_id={enquiry_id} events={events} navigate_from={navigate_from} refreshEnquiryDetails={refreshEnquiryDetails} readOnly={readOnly} />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: '100%', // Ensure it takes full width
        padding: { xs: '16px', sm: '24px' }, // Add padding for smaller screens
        marginLeft: { xs: 0, sm: '16px' }, // Align content to the left
      }}
    >
      {isConfirmed && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' }, // Stack vertically on smaller screens
            alignItems: 'flex-start',
            padding: '24px',
            gap: '16px',
            width: '100%', // Use full width
            backgroundColor: '#F4F7FD',
          }}
        >
          {/* Left Action Panel */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              width: { xs: '100%', sm: '242px' }, // Full width on smaller screens
              minWidth: '200px',
            }}
          >
            <ActionCard
              icon={<ReceiptLongIcon />}
              text="Invoice"
              active={activePanel === 'invoice'}
              onClick={() => setActivePanel('invoice')}
            />
  
            <ActionCard
              icon={<PersonAddIcon />}
              text="Event Vendors"
              active={activePanel === 'vendors'}
              onClick={() => setActivePanel('vendors')}
            />
  
            <ActionCard
              icon={<PhotoCameraFrontIcon />}
              text="Add Event Photos"
              active={activePanel === 'photos'}
              onClick={() => setActivePanel('photos')}
            />
          </Box>
  
          {/* Right Dynamic Panel */}
          <Box
            sx={{
              flexGrow: 1,
              maxWidth: { xs: '100%', sm: '70%' }, // Adjust width for smaller screens
              marginTop: { xs: '16px', sm: 0 }, // Add spacing for smaller screens
            }}
          >
            {renderRightPanel()}
          </Box>
        </Box>
      )}
    </Box>
  );
};

const ActionCard = ({ icon, text, active, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px',
      gap: '10px',
      width: '100%',
      height: '100px',
      backgroundColor: active ? '#1E3A8A' : '#FFFFFF',
      borderRadius: '10px',
      border: active ? 'none' : '1px solid #000000',
      cursor: 'pointer',
      transition: 'background 0.2s',
      '&:hover': {
        backgroundColor: active ? '#1E3A8A' : '#f0f0f0',
      },
    }}
  >
    <Box sx={{ color: active ? '#FFFFFF' : '#354052', fontSize: 24 }}>{icon}</Box>
    <Typography
      sx={{

        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '24px',
        color: active ? '#FFFFFF' : '#282828',
      }}
    >
      {text}
    </Typography>
  </Box>
);

export default DashboardActionPanel;
